(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okazo-withdrawal-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var storageKey = 'okazo-withdrawal-receipt';
    var form = document.getElementById('OkazoWithdrawalForm');
    var received = document.querySelector('[data-okazo-withdrawal-received]');

    if (received) {
      received.max = new Date().toISOString().slice(0, 10);
    }

    if (form) {
      form.addEventListener('submit', function () {
        var submittedAt = new Date().toISOString();
        var value = function (id) {
          var field = document.getElementById(id);
          return field ? field.value.trim() : '';
        };
        var receipt = {
          submittedAt: submittedAt,
          name: value('OkazoWithdrawal-name'),
          email: value('OkazoWithdrawal-email'),
          order: value('OkazoWithdrawal-order'),
          received: value('OkazoWithdrawal-received'),
          items: value('OkazoWithdrawal-items'),
          comment: value('OkazoWithdrawal-comment'),
        };
        var timestamp = form.querySelector('[data-okazo-withdrawal-timestamp]');
        var body = form.querySelector('[data-okazo-withdrawal-body]');
        if (timestamp) timestamp.value = submittedAt;
        if (body) {
          body.value =
            'Déclaration de rétractation en ligne\n' +
            'Commande : ' +
            receipt.order +
            '\n' +
            'Articles : ' +
            receipt.items +
            '\n' +
            'Date de réception : ' +
            (receipt.received || 'non renseignée') +
            '\n' +
            'Précisions : ' +
            (receipt.comment || 'aucune') +
            '\n' +
            'Envoyée le : ' +
            submittedAt;
        }
        try {
          sessionStorage.setItem(storageKey, JSON.stringify(receipt));
        } catch (error) {
          // The server-side submission remains available if browser storage is disabled.
        }
      });
    }

    var success = document.querySelector('[data-okazo-withdrawal-success]');
    if (!success) return;

    var receiptData;
    try {
      receiptData = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    } catch (error) {
      receiptData = null;
    }
    if (!receiptData) return;

    var confirmedAt = success.getAttribute('data-confirmed-at') || new Date().toISOString();
    var receiptText = [
      'ACCUSÉ DE RÉCEPTION DE RÉTRACTATION',
      'Okazo — WAVYZZ SARL',
      'SIREN 940 326 556 — 41 rue Jacquemars Giélée, 59800 Lille, France',
      '',
      'Déclaration envoyée : ' + receiptData.submittedAt,
      'Réception confirmée : ' + confirmedAt,
      'Nom et prénom : ' + receiptData.name,
      'Adresse électronique : ' + receiptData.email,
      'Numéro de commande : ' + receiptData.order,
      'Date de réception : ' + (receiptData.received || 'Non renseignée'),
      'Article(s) concerné(s) : ' + receiptData.items,
      'Précisions : ' + (receiptData.comment || 'Aucune'),
      '',
      'WAVYZZ confirme la réception de cette déclaration de rétractation.',
    ].join('\n');
    var receipt = success.querySelector('[data-okazo-withdrawal-receipt]');
    var download = success.querySelector('[data-okazo-withdrawal-download]');
    var blob = new Blob([receiptText], { type: 'text/plain;charset=utf-8' });
    var url = URL.createObjectURL(blob);

    receipt.textContent = receiptText;
    receipt.hidden = false;
    download.hidden = false;
    var downloadCopy = success.querySelector('[data-okazo-withdrawal-download-copy]');
    if (downloadCopy) downloadCopy.hidden = false;
    download.addEventListener('click', function () {
      var link = document.createElement('a');
      link.href = url;
      link.download = 'accuse-reception-retractation-okazo.txt';
      link.click();
    });
    download.click();
    success.focus();
  })();

  } catch(e) { console.error(e); }
})();
})();
